import { render, staticRenderFns } from "./CalculationStats.vue?vue&type=template&id=217e85ea&scoped=true"
import script from "./CalculationStats.vue?vue&type=script&lang=ts"
export * from "./CalculationStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e85ea",
  null
  
)

export default component.exports